import { render } from "./PayPassword.vue?vue&type=template&id=3df21cce&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=3df21cce&lang=scss&scoped=true"
import "./PayPassword.vue?vue&type=style&index=1&id=3df21cce&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df21cce"]])

export default __exports__